// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2IMmEo0iu5p8bgchAuh41W"};